// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"5b222416","166":"fd7237b0","340":"39685c57","900":"b82170df"}[chunkId] + ".chunk.js";
};